export default "__VITE_ASSET__FTBXHR0l__"